<template>
  <div style="max-height: calc(100vh - 100px)">
    <div v-if="loading" class="text-center" style="margin-top: 2em;">
      <img src="@/img/hensel-loading.svg" alt="loading">
    </div>
    <div v-else class="favorites view"
         ref="scrollView" @scroll="onScroll">
      <title-bar :with-logo="false" :title="title"></title-bar>

      <div class="container">
        <div class="row">
          <div class="col-xs-12 spacer-bottom">
            <button :class="items.length === 0?'bg-light':'bg-blue'"
                    @click="sendFavorites"
                    :disabled="items.length === 0 || lockSendButton"
            >
              <img v-if="lockSendButton"
                   src="@/img/hensel-loading.svg"
                   alt="..."
                   style="max-height: 1.2em">
              <template v-else>
                {{
                  _('Favoriten an HENSEL RECYCLING schicken')
                }}&nbsp;&nbsp;&nbsp;&nbsp;<i style="font-size: 1.5em" class="fas fa-paper-plane"></i>
              </template>
            </button>
            <button type="button"
                    :class="items.length === 0?'bg-light':'bg-blue'" :disabled="items.length === 0"
                    @click="clearAllModal = true"
            >{{ _('Alle Favoriten löschen') }} <i class="fas fa-trash-alt"></i>
            </button>
          </div>

        </div>
      </div>
      <div v-if="items.length > 0 && watermark"
           ref="search_results"
           id="search_results"
           class="bs4-container-fluid bg-white spacer-bottom">
        <div class="bs4-row">
          <template v-for="(item, idx) in visibleItems">
            <div
                class="bs4-col-12 bs4-col-lg-3 bs4-col-xl-2"
                :class="{'last-item': idx === items.length-2}"
            >
              <kat-list-item
                  :key="`favorite-${item.id}`"
                  :item="item"
                  :favorite="isInInventory(item.id)"
                  :watermark="watermark"
                  :class="{'last-item': idx === visibleItems.length-2}"

                  @toggle-favorite="toggleFavorite(item)"
                  @process-img="forwardProcessImgEvent"
                  @enlarge-img="zoomedImage = $event"
                  @open="$router.push('/detail/'+$event, () => null, () => null)"
              >
                <number-input
                    :key="`favorite-input-${item.id}`"
                    :value="amountForConverter(item)"
                    @input="updateConverter(item, $event)"
                />
              </kat-list-item>
            </div>
          </template>
        </div>
      </div>
      <div v-else class="container spacer-y">
        <div class="row spacer-y">
          <div class="col-xs-12 text-center spacer-y">
            <h3>
              {{ _('Sie haben noch keine Favoriten!') }}
            </h3>
            <img class="spacer-top" src="@/img/save-unchecked.svg">
            <p>
              {{
                _('Tippen Sie im Katalog auf das Lesezeichen des Materials, um es zu den Favoriten hinzuzufügen.')
              }}</p>
          </div>
        </div>
      </div>


      <modal :visible="clearAllModal"
             :positive-button="_('Löschen')"
             :negative-button="_('Abbrechen')"
             @positive-response="clearInventory"
             @negative-response="clearAllModal = false"
      >
        <p v-html="sprintf(_('Wollen Sie wirklich <b>alle %s</b> Katalysatoren aus Ihrer Merkliste löschen?'), items.length)"></p>
      </modal>

      <pinch-zoom-overlay :image="zoomedImage" @hide="zoomedImage = ''"></pinch-zoom-overlay>
    </div>
  </div>
</template>
<script>
import {mapActions, mapMutations, mapState} from 'vuex'
import forwardEvents from "../mixins/forwardEvents"
import inventoryHelper from "../mixins/inventory-helper"
import TitleBar from "../components/TitleBar";
import PinchZoomOverlay from "../components/PinchZoomOverlay";
import KatListItem from "../components/KatListItem";
import NumberInput from "../components/NumberInput";
import Modal from "@/components/Modal";

export default {
  name: "Favorites",
  mixins: [forwardEvents, inventoryHelper],
  components: {
    Modal,
    NumberInput,
    KatListItem,
    PinchZoomOverlay,
    TitleBar
  },
  data() {
    return {
      zoomedImage: "",
      itemsCount: 10,
      clearAllModal: false,
      lockSendButton: false,
      loading: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.Api.Users.current,
      items: state => state.Api.Inventory.converters
    }),
    title() {
      return this._('Favoriten')
    },
    watermark() {
      if (!this.user) {
        return null
      }

      return this.user.watermark
    },
    visibleItems() {
      return this.items.slice(0, this.itemsCount)

    }
  },
  methods: {
    ...mapActions({
      refreshListOfInventories: 'Api/Inventory/all',
      refreshInventory: 'Api/Inventory/get',
      sendToBv: 'Api/Inventory/sendToBv'
    }),
    ...mapMutations({
      clearInventoryConverters: 'Api/Inventory/clearConverters',
      setModalContent: "setLatestError"
    }),
    zoomImage(image) {
      this.zoomedImage = image
    },
    sendFavorites() {
      this.lockSendButton = true
      this.sendToBv(this.inventoryId)
          .then(() => {
            this.setModalContent({
              code: 0,
              message: this._('Merkliste erfolgreich versendet'),
              hidden: false
            })
          })
          .catch(this.apiErrorHandler)
          .finally(() => this.lockSendButton = false)
    },
    onScroll() {

      if (!this.$refs.scrollView) {
        return
      }

      //fetch more  converters when scrolls to the end of the list
      let lastItem = this.$refs.scrollView.getElementsByClassName('last-item')[0];
      if (lastItem
          && lastItem.offsetTop - this.$refs.scrollView.clientHeight < this.$refs.scrollView.scrollTop
          && this.itemsCount < this.items.length) {
        console.log('load next page!')
        this.itemsCount += 10;
      }
    },
    askClearInventory() {

    },
    clearInventory() {
      this.addInventory({
        currency_id: this.user.currency_id,
        inventory_converters: []
      })
          .then(this.refreshInventory)
          .then(() => this.clearAllModal = false)
          .catch(this.apiErrorHandler);
    }
  },
  mounted() {
    if (!this.user) {
      this.$router.push({ name: 'Login' })
      return;
    }

    this.unsubscribeStore = this.$store.subscribe(async (mutation, state) => {
      if (mutation.type === "Api/Inventory/setCurrent") {
        this.loading = true

        let converterIds = mutation.payload.item.inventory_converters.map(el => el.converter_id)

        if (converterIds.length === 0) {
          this.clearInventoryConverters();
          console.log('inventory is empty')

          this.loading = false
          return
        }

        try {
          await this.refreshInventoryConverters({filter: {id: converterIds}})
        } catch (err) {
          this.apiErrorHandler(err)
        } finally {
          this.loading = false
        }
      }
    })
  },
  beforeDestroy() {
    if (this.unsubscribeStore) {
      this.unsubscribeStore();
    }
  },
}
</script>
